export class RemovePlayerBetRequest {
    static Message = 'RemovePlayerBetRequest';
}

export class RemovePlayerBetResponse {
    static Message = 'RemovePlayerBetResponse';

    public socketId: string;

    constructor(socketId: string) {
        this.socketId = socketId;
    }
}
